import * as React from 'react'

const SvgUnlockedFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={14} height={18} viewBox="0 0 14 18" fill="none" {...props}>
    <path
      d="M4.5 7.75H12c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V9c0-.69.56-1.25 1.25-1.25h1.25V4a3.75 3.75 0 117.5 0H9.5a2.5 2.5 0 00-5 0v3.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgUnlockedFilledIcon
